module.exports = __webpack_public_path__ + "img/mobile.bdfc895d.png";